import React from 'react';
import { TextField, useTheme } from '@mui/material';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterLuxon } from '@mui/x-date-pickers/AdapterLuxon';
import { DateTime } from 'luxon';
import { parseDateValue } from 'utils/dateUtils';

interface SingleDatePickerMAIQProps {
  value: string | null;
  onChange: (date: string | null) => void;
  label?: string;
  placeholder?: string;
  size?: 'small' | 'medium';
  fullWidth?: boolean;
  disabled?: boolean;
  minDate?: string | Date | DateTime | null;
  maxDate?: string | Date | DateTime | null;
  error?: boolean;
  helperText?: string;
}

const SingleDatePickerMAIQ: React.FC<SingleDatePickerMAIQProps> = ({
  value,
  onChange,
  label,
  placeholder = 'Select date',
  size = 'small',
  fullWidth = true,
  disabled = false,
  minDate,
  maxDate,
  error = false,
  helperText,
}) => {
  const theme = useTheme();

  const toDateTime = (input?: string | Date | DateTime | null) => {
    const parsed = parseDateValue(input ?? undefined);
    return parsed ?? undefined;
  };

  const handleDateChange = (date: DateTime | null) => {
    onChange(date ? date.startOf('day').toUTC().toISO() : null);
  };

  const dateValue = value ? parseDateValue(value) : null;

  return (
    <LocalizationProvider dateAdapter={AdapterLuxon}>
      <DatePicker
        label={label}
        value={dateValue}
        onChange={handleDateChange}
        minDate={toDateTime(minDate)}
        maxDate={toDateTime(maxDate)}
        disabled={disabled}
        slotProps={{
          textField: {
            size,
            fullWidth,
            placeholder,
            error,
            helperText,
            // InputProps: {
            //   endAdornment: (
            //     <InputAdornment position="end">
            //       <CalendarTodayIcon
            //         sx={{ color: 'text.secondary', fontSize: 20 }}
            //       />
            //     </InputAdornment>
            //   ),
            // },
            sx: {
              '& .MuiOutlinedInput-root': {
                borderRadius: 1,
                backgroundColor: 'background.paper',
                '&:hover fieldset': {
                  borderColor: theme.palette.secondary.main,
                },
                '&.Mui-focused fieldset': {
                  borderColor: theme.palette.secondary.main,
                },
              },
            },
          },
        }}
      />
    </LocalizationProvider>
  );
};

export default SingleDatePickerMAIQ;
